import { Button } from "../ui/Button";
import { motion } from "framer-motion";
import TypingSection from "./TypingSection";
import logo from "../assets/img/logo.png";
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import qualifications from "../utils/qualifications";
import secteursList from "../utils/secteurs";
import prestations from "../utils/prestations";
import { Input } from "../ui/Input";
import { Textarea } from "../ui/TextArea";
import axios from "../axios/AxiosInstance";
import { Label } from "../ui/Label";
import { Checkbox } from "../ui/Checkbox";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../components/reusableComponents/Select";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../ui/Tabs";
import { toast, Toaster } from "sonner";
import MultiSelect from "../components/reusableComponents/MultiSelect";

export default function Contact() {
  console.log("Page Contact rendue");

  const location = useLocation();
  const title = location.state?.title;
  const [defaultValue, setDefaultValue] = useState("client");

  const [candSelectedOptions, setCandSelectedOptions] = useState([]);
  const [recruteurSelectedOptions, setRecruteurSelectedOptions] = useState([]);
  const [prestationsSelectedOptions, setPrestationsSelectedOptions] = useState(
    [],
  );
  const [loading, setLoading] = useState(false);

  const agences = [
    {
      id: "asnières",
      name: " J'M intérim - Asnières sur Seine",
      logo: logo,
      email: "recrutement@jm-interim.com",
      email2: "contact@jm-interim.com",
      phone: "01 80 88 21 35",
      address: "4 avenue Laurent Cély, hall A, 92600 Asnières sur Seine",
    },

    {
      id: "brive",
      name: " J'M capeneo - Brive la gaillarde",
      logo: logo,
      email: "brive@jm-interim.com",
      phone: "05 55 17 49 79",
      address: " 26 Bis Av. Ribot,19100 Brive-la-Gaillarde",
    },
    {
      id: "toulouse",
      name: " J'M capeneo santé - Toulouse",
      logo: logo,
      email: "sante@jm-interim.com",
      phone: "05 61 11 11 00",
      address:
        " Carré Wilson, 64 Rue Benjamin Baillaud Bâtiment C, 31500 Toulouse",
    },
  ];

  const [selectedId, setSelectedId] = useState(agences[0].id);
  const selectedAgency = agences.find((a) => a.id === selectedId);
  const secteurs = candSelectedOptions.map((opt) => opt.value); // récupération depuis react-select

  const handleClientSubmit = (event) => {
    event.preventDefault(); // tout de suite !

    const data = new FormData(event.target);

    const payload = {
      companyName: data.get("companyName"),
      siret: data.get("siret"),
      address: data.get("address"),
      postCode: data.get("postCode"),
      town: data.get("town"),
      TVA: data.get("TVA"),
      tvaRate: data.get("tvaRate"),
      APE: data.get("APE"),

      contactFirstname: data.get("contactFirstname"),
      contactLastname: data.get("contactLastname"),
      contactEMail: data.get("contactEMail"),
      contactPhone: data.get("contactPhone"),
      facturation: data.get("facturation"),
      agencyId: data.get("agencyId"),
      needType: data.get("needType"),
      messageClient: data.get("messageClient"),
    };

    if (!data.get("privacyClient")) {
      toast.error("Veuillez accepter la politique de confidentialité.");
      return;
    }
    console.log("Payload client :", payload);

    axios
      .post("/client/website", payload)
      .then((res) => {
        toast.success("Votre demande a bien été envoyée !");
      })
      .catch((err) => {
        console.error("400 details:", err.response?.data);
        const status = err.response?.status;
        if (status === 409) {
          toast.error("Votre profil existe déjà.");
        } else {
          toast.error("Une erreur est survenue. Merci de réessayer.");
        }
      });
  };

  return (
    <div className="flex flex-col min-h-screen">
      <header className="fixed top-0 z-50 w-full bg-white border-b border-gray-200">
        <div className="container mx-auto px-4 h-20 flex items-center justify-between">
          <Link to="/">
            <div className="w-24  h-24 overflow-hidden">
              {" "}
              {/* Conteneur avec taille fixe */}
              <motion.img
                key={logo}
                src={logo}
                className="w-full h-full object-contain"
                animate={{ rotate: 360 }} // Applique la rotation de 360°
                transition={{ duration: 2, ease: "easeOut" }} // Durée de l'animation
              />
            </div>
          </Link>
          <nav className="hidden md:flex gap-6 items-center"></nav>
          <div className="flex items-center gap-3">
            <Link to="/login">
              <button className="inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 hover:bg-accent hover:text-accent-foreground h-10 px-4 py-2 bg-transparent text-primary">
                Connexion
              </button>
            </Link>
            <Link to="/contact">
              <button className="inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2">
                Inscription
              </button>
            </Link>
          </div>
        </div>
      </header>
      <Toaster position="top-right" richColors />

      <main className="flex-grow">
        <section className="bg-gradient-to-r from-blue-50 to-indigo-50 pt-[154px] pb-16">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto text-center mb-10">
              <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                Contactez-nous
              </h1>
              <p className="text-lg text-gray-700">
                Notre équipe est là pour vous aider.
              </p>
            </div>
          </div>
        </section>

        <section className="py-16 bg-white">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
              <div className="bg-white p-8 rounded-lg shadow-md border border-gray-200">
                <Tabs defaultValue={defaultValue}>
                  {/* Client Form */}
                  <TabsContent value="client">
                    <h2 className="text-2xl font-bold text-gray-900 mb-6">
                      Contact Entreprise
                    </h2>
                    <form onSubmit={handleClientSubmit} className="space-y-6">
                      {/* Nom de l'entreprise */}
                      <div className="space-y-2">
                        <Label htmlFor="companyName">
                          Nom de l'entreprise *
                        </Label>
                        <Input
                          id="companyName"
                          name="companyName"
                          placeholder="Nom de l'entreprise"
                          required
                          className="w-full"
                        />
                      </div>

                      {/* Numéro de SIRET */}
                      <div className="space-y-2">
                        <Label htmlFor="siret">Numéro de SIRET *</Label>
                        <Input
                          id="siret"
                          name="siret"
                          placeholder="Numéro de SIRET"
                          required
                          className="w-full"
                        />
                      </div>

                      {/* Adresse */}
                      <div className="space-y-2">
                        <Label htmlFor="address">Adresse *</Label>
                        <Input
                          id="address"
                          name="address"
                          placeholder="Adresse"
                          required
                          className="w-full "
                        />
                      </div>

                      {/* Code Postal */}
                      <div className="space-y-2">
                        <Label htmlFor="postCode">Code Postal *</Label>
                        <Input
                          id="postCode"
                          name="postCode"
                          placeholder="Code postal"
                          required
                          className="w-full"
                        />
                      </div>

                      {/* Ville */}
                      <div className="space-y-2">
                        <Label htmlFor="town">Ville *</Label>
                        <Input
                          id="town"
                          name="town"
                          placeholder="Ville"
                          required
                          className="w-full md:w-2/3"
                        />
                      </div>
                      <div className="space-y-2 placeholder-gray-only text-gray-400">
                        <MultiSelect
                          options={prestations}
                          selected={prestationsSelectedOptions}
                          setSelected={setPrestationsSelectedOptions}
                          name="prestation"
                          label="Prestations *"
                          placeholder="Sélectionnez le(s) prestations recherchées"
                        />
                      </div>

                      <div className="space-y-2">
                        <Label htmlFor="TVA">
                          Numéro de TVA intracommunautaire{" "}
                        </Label>
                        <Input
                          id="TVA"
                          name="TVA"
                          placeholder="FRXX123456789"
                          required
                          className="w-full"
                        />
                      </div>

                      <div className="space-y-2">
                        <Label htmlFor="APE">Code APE </Label>
                        <Input
                          id="APE"
                          name="APE"
                          placeholder="0000Z"
                          required
                          className="w-full"
                        />
                      </div>

                      {/* Prénom et Nom du contact en ligne */}
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div className="space-y-2">
                          <Label htmlFor="contactFirstname">
                            Prénom du contact *
                          </Label>
                          <Input
                            id="contactFirstname"
                            name="contactFirstname"
                            placeholder="Prénom"
                            required
                            className="w-full"
                          />
                        </div>
                        <div className="space-y-2">
                          <Label htmlFor="contactLastname">
                            Nom du contact *
                          </Label>
                          <Input
                            id="contactLastname"
                            name="contactLastname"
                            placeholder="Nom"
                            required
                            className="w-full"
                          />
                        </div>
                      </div>

                      {/* Email et téléphone du contact en ligne */}
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div className="space-y-2">
                          <Label htmlFor="contactEMail">
                            Email du contact *
                          </Label>
                          <Input
                            id="contactEMail"
                            name="contactEMail"
                            type="email"
                            placeholder="contact@entreprise.com"
                            required
                            className="w-full"
                          />
                        </div>
                        <div className="space-y-2">
                          <Label htmlFor="contactPhone">
                            Téléphone du contact *
                          </Label>
                          <Input
                            id="contactPhone"
                            name="contactPhone"
                            type="tel"
                            placeholder="Téléphone"
                            required
                            className="w-full"
                          />
                        </div>
                      </div>

                      {/* Agence concernée */}
                      <div className="space-y-2">
                        <Label htmlFor="agencyId">Agence concernée *</Label>
                        <Select required name="agencyId" className="w-full">
                          <SelectTrigger
                            id="agencyId"
                            name="agencyId"
                            className="text-gray-400"
                          >
                            <SelectValue placeholder="Sélectionnez une agence" />
                          </SelectTrigger>
                          <SelectContent className="bg-white">
                            <SelectItem value="650adee7951dd697c7535e3e">
                              J'm intérim - Asnières-sur-Seine (92)
                            </SelectItem>
                            <SelectItem value="6533fe25099978decf532a59">
                              J'm Capeneo - Brive (19)
                            </SelectItem>
                            <SelectItem value="654a3d82874a059df3f98653">
                              J'm Capeneo Santé - Toulouse (31)
                            </SelectItem>
                          </SelectContent>
                        </Select>
                      </div>

                      {/* Type de besoin */}
                      <div className="space-y-2">
                        <Label htmlFor="needType">Type de besoin *</Label>
                        <Select required name="needType" className="w-full">
                          <SelectTrigger
                            id="needType"
                            className="text-gray-400"
                          >
                            <SelectValue placeholder="Sélectionnez votre besoin" />
                          </SelectTrigger>
                          <SelectContent className="bg-white">
                            <SelectItem value="interim">Intérim</SelectItem>
                            <SelectItem value="cdd">Recrutement CDD</SelectItem>
                            <SelectItem value="cdi">Recrutement CDI</SelectItem>
                            <SelectItem value="information">
                              Demande d'information
                            </SelectItem>
                          </SelectContent>
                        </Select>
                      </div>

                      {/* Description du besoin */}
                      <div className="space-y-2">
                        <Label htmlFor="messageClient">
                          Description de votre besoin *
                        </Label>
                        <Textarea
                          id="messageClient"
                          name="messageClient"
                          placeholder="Décrivez le poste, le profil recherché, la durée, etc..."
                          rows={4}
                          required
                          className="w-full"
                        />
                      </div>

                      {/* Privacy checkbox */}
                      <div className="flex items-center space-x-2">
                        <Checkbox
                          id="privacyClient"
                          name="privacyClient"
                          required
                        />
                        <Label
                          htmlFor="privacyClient"
                          className="text-sm text-gray-600 font-normal"
                        >
                          J'accepte que mes données soient traitées conformément
                          aux{" "}
                          <a
                            href="/politique-confidentialite"
                            className="text-blue-600 hover:underline"
                          >
                            Conditions Générales de Vente
                          </a>
                          *
                        </Label>
                      </div>

                      <Button
                        type="submit"
                        className="w-full bg-blue-600 hover:bg-blue-700 text-white"
                      >
                        Envoyer ma demande
                      </Button>
                      <p className="text-sm text-gray-500 pt-2">
                        Les champs marqués d'un * sont obligatoires
                      </p>
                    </form>
                  </TabsContent>
                </Tabs>
              </div>
              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-6">
                  Nos coordonnées
                </h2>

                <div className="space-y-8">
                  <div className="flex items-start">
                    <div className="flex-shrink-0 bg-blue-100 rounded-full p-3 mr-4">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6 text-blue-600"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                        />
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                        />
                      </svg>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-1">
                        Adresse du siège social
                      </h3>
                      <a
                        href="https://www.google.com/maps/search/?api=1&query=J'M+Intérim+4+avenue+Laurent+Cely+hall+A+92600+Asnières-sur-Seine"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-gray-400 hover:underline"
                      >
                        <p className="text-gray-700">
                          4 avenue Laurent Cely, hall A, 92600
                          Asnières-sur-Seine
                        </p>{" "}
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="flex-shrink-0 bg-blue-100 rounded-full p-3 mr-4">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6 text-blue-600"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                        />
                      </svg>
                    </div>
                    <div>
                      <a href="tel:0180882135">
                        <h3 className="text-lg font-semibold text-gray-900 mb-1">
                          Téléphone
                        </h3>
                        <p className="text-gray-700 mb-1">
                          01.80.88.21.35
                        </p>{" "}
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="flex-shrink-0 bg-blue-100 rounded-full p-3 mr-4">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6 text-blue-600"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                        />
                      </svg>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-1">
                        Email
                      </h3>

                      <a
                        href="mailto:contact@jm-interim.com"
                        className="text-gray-400"
                      >
                        <p className="text-gray-700 mb-1">
                          Informations générales : contact@jm-interim.com
                        </p>{" "}
                      </a>
                      <a href="mailto:recrutement@jm-interim.com">
                        <p className="text-gray-700 mb-1">
                          Candidatures Asnières (92) :
                          recrutement@jm-interim.com
                        </p>
                      </a>
                      <a href="mailto: brive@jm-interim.com">
                        <p className="text-gray-700 mb-1">
                          Candidatures Brive (19) : brive@jm-interim.com
                        </p>
                      </a>
                      <a href="mailto:sante@jm-interim.com">
                        <p className="text-gray-700 mb-1">
                          Candidatures Toulouse (31) : sante@jm-interim.com
                        </p>
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="flex-shrink-0 bg-blue-100 rounded-full p-3 mr-4">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6 text-blue-600"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-1">
                        Horaires d'ouverture
                      </h3>
                      <p className="text-gray-700 mb-1">
                        Lundi - Vendredi : 8h00 - 18h00
                      </p>
                      <p className="text-gray-700">Samedi - Dimanche : Fermé</p>
                      <br></br>
                      <Link to="/a-propos">
                        <p className="text-blue-500 underline">
                          Voir nos autres agences
                        </p>
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="mt-10">
                  <h3 className="text-lg font-semibold text-gray-900 mb-4">
                    Suivez-nous
                  </h3>
                  <div className="flex space-x-4">
                    <a
                      href="https://www.facebook.com/jm.interim"
                      className="bg-blue-100 hover:bg-blue-200 text-blue-600 p-3 rounded-full transition-colors"
                    >
                      <svg
                        className="h-6 w-6"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                        aria-hidden="true"
                      >
                        <path
                          fillRule="evenodd"
                          d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </a>

                    <a
                      href="https://www.instagram.com/jm_interim/#"
                      className="bg-blue-100 hover:bg-blue-200 text-blue-600 p-3 rounded-full transition-colors"
                    >
                      <svg
                        className="h-6 w-6"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                        aria-hidden="true"
                      >
                        <path
                          fillRule="evenodd"
                          d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      {/* Footer */}
      <TypingSection></TypingSection>
      <footer className="bg-gray-900 text-white pt-16 pb-8">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 mb-16">
            <div>
              <div className="flex items-center mb-6">
                <span className="text-2xl font-bold text-blue-400">J'❤️ </span>
                <span className="text-2xl font-bold ml-1 text-white">
                  INTÉRIM
                </span>
              </div>
              <p className="text-gray-400 mb-6">
                Votre partenaire de confiance pour le recrutement temporaire et
                permanent depuis plus de 17 ans.
              </p>
              <div className="flex space-x-4">
                <a
                  href="https://www.facebook.com/jm.interim"
                  className="text-gray-400 hover:text-white"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 32 32"
                    width="32"
                    height="32"
                  >
                    <circle cx="16" cy="16" r="16" fill="#1877F2" />
                    <path
                      fill="#FFF"
                      d="M22 11h-3c-.6 0-1 .4-1 1v2h4l-.5 4h-3.5v9h-4v-9H11v-4h3v-2.5C14 8.6 15.1 7 17.5 7H22v4z"
                    />
                  </svg>
                </a>

                <a
                  href="https://www.instagram.com/jm_interim/#"
                  className="text-gray-400 hover:text-white"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    width="32"
                    height="32"
                  >
                    <linearGradient
                      id="insta-gradient"
                      x1="0"
                      y1="0"
                      x2="1"
                      y2="1"
                    >
                      <stop offset="0%" stop-color="#f58529" />
                      <stop offset="50%" stop-color="#dd2a7b" />
                      <stop offset="100%" stop-color="#515bd4" />
                    </linearGradient>
                    <rect
                      width="512"
                      height="512"
                      rx="15%"
                      fill="url(#insta-gradient)"
                    />
                    <path
                      d="M256 164.1c-50.7 0-91.9 41.2-91.9 91.9S205.3 348 256 348s91.9-41.2 91.9-91.9S306.7 164.1 256 164.1zm0 151.7c-33 0-59.8-26.8-59.8-59.8s26.8-59.8 59.8-59.8 59.8 26.8 59.8 59.8-26.8 59.8-59.8 59.8zm116.4-152.6c0 11.8-9.6 21.3-21.3 21.3s-21.3-9.6-21.3-21.3 9.6-21.3 21.3-21.3 21.3 9.5 21.3 21.3z"
                      fill="#fff"
                    />
                    <path
                      d="M370.5 144h-229C111 144 96 159 96 181.5v149c0 22.5 15 37.5 37.5 37.5h229c22.5 0 37.5-15 37.5-37.5v-149c0-22.5-15-37.5-37.5-37.5zm-114.5 226.8c-63 0-114.3-51.2-114.3-114.3S193 142.3 256 142.3 370.3 193.6 370.3 256.5 319 370.8 256 370.8zm116.4-152.6c-11.8 0-21.3-9.6-21.3-21.3s9.6-21.3 21.3-21.3 21.3 9.6 21.3 21.3-9.6 21.3-21.3 21.3z"
                      fill="#fff"
                    />
                  </svg>
                </a>
                <a
                  href="https://api.whatsapp.com/send/?phone=%2B33756107886&text&type=phone_number&app_absent=0"
                  className="text-gray-400 hover:text-white"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 32 32"
                    width="32"
                    height="32"
                  >
                    <path
                      fill="#25D366"
                      d="M16.001 3C9.373 3 4 8.373 4 15.001c0 2.688.883 5.17 2.376 7.188L4 29l7.004-2.288A11.948 11.948 0 0016.001 27c6.628 0 12.001-5.373 12.001-11.999C28.002 8.373 22.629 3 16.001 3z"
                    />
                    <path
                      fill="#fff"
                      d="M22.093 19.182c-.356-.178-2.103-1.038-2.427-1.156-.326-.119-.564-.178-.802.178-.237.356-.919 1.156-1.127 1.393-.208.237-.416.267-.772.089-.356-.178-1.504-.553-2.864-1.765-1.058-.945-1.771-2.108-1.98-2.464-.208-.356-.022-.547.157-.724.161-.16.356-.415.534-.623.178-.208.237-.356.356-.594.119-.237.06-.445-.03-.624-.089-.178-.802-1.931-1.099-2.639-.29-.696-.583-.601-.802-.612l-.683-.012c-.237 0-.623.089-.949.445-.326.356-1.246 1.215-1.246 2.962 0 1.748 1.276 3.445 1.454 3.682.178.237 2.513 3.833 6.157 5.187.86.296 1.533.473 2.057.604.864.273 1.65.235 2.273.143.694-.103 2.103-.859 2.401-1.688.296-.83.296-1.539.208-1.688-.089-.148-.326-.237-.683-.415z"
                    />
                  </svg>
                </a>
              </div>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-6">Nos agences</h3>

              <ul className="space-y-4">
                <li className="text-gray-400">
                  J'm intérim Asnières sur Seine (92)
                </li>
                <li className="text-gray-400">
                  J'm Capeneo Santé Toulouse (31)
                </li>
                <li className="text-gray-400">J'm Capeneo Brive (19)</li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-6">Siège</h3>
              <ul className="space-y-4">
                <li className="flex items-start">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6 text-gray-400 mr-3 flex-shrink-0"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                  </svg>
                  <a
                    href="https://www.google.com/maps/search/?api=1&query=J'M+Intérim+4+avenue+Laurent+Cely+hall+A+92600+Asnières-sur-Seine"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-400 hover:underline"
                  >
                    4 avenue Laurent Cely, hall A, 92600 Asnières-sur-Seine
                  </a>
                </li>

                <li className="flex items-start">
                  <a href="tel:0180882135" className="flex items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6 text-gray-400 mr-3 flex-shrink-0"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                      />
                    </svg>
                    <span className="text-gray-400">01 80 88 21 35</span>
                  </a>
                </li>

                <li className="flex items-start">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6 text-gray-400 mr-3 flex-shrink-0"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    />
                  </svg>
                  <a
                    href="mailto:contact@jm-interim.com"
                    className="text-gray-400"
                  >
                    contact@jm-interim.com
                  </a>
                </li>

                <li className="flex items-start">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6 text-gray-400 mr-3 flex-shrink-0"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                  <span className="text-gray-400">
                    Lundi - Vendredi: 8h - 18h
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-800 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <p className="text-gray-400 text-sm mb-4 md:mb-0">
                &copy; {new Date().getFullYear()} J'M INTÉRIM. Tous droits
                réservés.
              </p>
              <div className="flex space-x-6">
                <Link
                  to="/politique"
                  className="text-gray-400 hover:text-white text-sm"
                >
                  Politique de confidentialité/RGPD
                </Link>
                <Link
                  to="/mentions"
                  className="text-gray-400 hover:text-white text-sm"
                >
                  Mentions légales
                </Link>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
